function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "54",
  height: "55",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "4.918",
  width: "46",
  height: "46",
  rx: "23",
  fill: "#F4EBFF"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "4.918",
  width: "46",
  height: "46",
  rx: "23",
  stroke: "#F9F5FF",
  strokeWidth: "8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 23.919l8.165 5.715c.661.463.992.694 1.351.784.318.079.65.079.968 0 .36-.09.69-.321 1.351-.784L38 23.919m-15.2 13h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.312C38 34.64 38 33.8 38 32.118v-6.4c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.31c-.642-.327-1.482-.327-3.162-.327H22.8c-1.68 0-2.52 0-3.162.326a3 3 0 00-1.311 1.311C18 23.198 18 24.038 18 25.718v6.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.312c.642.327 1.482.327 3.162.327z",
  stroke: "#7F56D9",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));